// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__CatalogItemsList__AddCatalogItemSidebar__root","header":"CentricUI__CatalogItemsList__AddCatalogItemSidebar__header","title":"CentricUI__CatalogItemsList__AddCatalogItemSidebar__title","form":"CentricUI__CatalogItemsList__AddCatalogItemSidebar__form","actions":"CentricUI__CatalogItemsList__AddCatalogItemSidebar__actions","input":"CentricUI__CatalogItemsList__AddCatalogItemSidebar__input"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/sidebar/CatalogItemsList/AddCatalogItemSidebar.css
// module id = 1468
// module chunks = 10